import { useLayoutEffect } from 'react';

export function ScrollToBottom() {
  useLayoutEffect(() => {
    window.scrollTo(0, document.body.scrollHeight);
  }, []);

  return null;
}
